/**
 * Parse API response to extract data array.
 * Handles different response structures:
 * - Browser (with proxy): direct array
 * - Native (CapacitorHttp): Hydra collection with 'member' property
 *
 * @param {Object|Array} response - API response
 * @returns {Array} - Parsed data array
 */
export const parseApiResponse = (response) => {
  if (Array.isArray(response)) {
    return response;
  } else if (response.member && Array.isArray(response.member)) {
    // Hydra collection format (native platform)
    return response.member;
  } else if (response.data) {
    return Array.isArray(response.data) ? response.data : response.data.member || [];
  }
  return [];
};
